import { STANDARD_BRANCH } from '@festina-life/api'
import type { ConfigurableServer, Optional } from '@festina-life/core'

import { ServerServices } from '../uiModels/openApiServices'
import { useConfigurationComponentAvailability } from './useConfigurationComponentAvailability'

export type ServerServicesType =
  | typeof ServerServices.collCalc
  | typeof ServerServices.life
  | typeof ServerServices.legalEntity
  | typeof ServerServices.unitLink
  | typeof ServerServices.moneyIn
  | typeof ServerServices.moneyOut
  | typeof ServerServices.configuration

/** Helper hook used to retrieve the current OpenAPI specification based on the currently active server. Astracts the
 * standard component services and the configuration component services into a common API. */
export const useService = (
  server: Optional<ConfigurableServer>,
  branchName?: Optional<string>,
): Optional<ServerServicesType> => {
  const isConfigurationComponentAvailable =
    useConfigurationComponentAvailability()

  if (!server) {
    return undefined
  }

  if (
    !!branchName &&
    branchName !== STANDARD_BRANCH &&
    !isConfigurationComponentAvailable
  ) {
    throw new Error('The configuration component is not available.')
  }

  if (!ServerServices[server]) {
    throw new Error(`Unknown server: ${server}`)
  }

  const isServerConfigured = ServerServices[server].api.OpenAPI.BASE

  if (
    branchName !== STANDARD_BRANCH ||
    (isConfigurationComponentAvailable && !isServerConfigured)
  ) {
    return ServerServices.configuration
  }

  if (!server || !ServerServices[server]) {
    throw new Error(`Unknown server: ${server}`)
  }

  return ServerServices[server]
}
